// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"t5-z","colorTextValue":"u5-z","swatches":"v5-z","collapseLink":"w5-z","isCollapsed":"x5-z","dropdown":"y5-z","disabled":"z5-z"};